export default __webpack_public_path__ + "static/media/bitpink.2f4de0bd.svg";